import React from "react";
import {
  Box,
  Text,
  HStack,
  Button,
  SimpleGrid,
  CardRoot,
  CardHeader,
  CardBody,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  StatRoot,
  StatLabel,
} from "@chakra-ui/react";

const stats = [
  { label: "Total Leads", value: 248 },
  { label: "New", value: 87 },
  { label: "Contacted", value: 61 },
  { label: "Qualified", value: 38 },
  { label: "Pending", value: 62 },
];

const recentLeads = [
  {
    name: "Jane Doe",
    email: "jane@example.com",
    status: "New",
    resortName: "Oceanview Resort",
  },
  {
    name: "John Smith",
    email: "john@example.com",
    status: "Contacted",
    resortName: "Mountain Escape Lodge",
  },
  {
    name: "Sara Lee",
    email: "sara@example.com",
    status: "Qualified",
    resortName: "Palm Bay Suites",
  },
];

const AdminDashboard = () => {
  return (
    <Box p={6} bg="gray.50" minH="100vh">
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        Admin Dashboard
      </Text>

      <SimpleGrid columns={[1, 2, 3, 5]} gap={4} mb={8}>
        {stats.map((stat) => (
          <CardRoot key={stat.label} borderRadius="2xl" shadow="sm" p={4}>
            <StatRoot>
              <StatLabel>{stat.label}</StatLabel>
              <Text fontSize="2xl" fontWeight="bold">
                {stat.value}
              </Text>
            </StatRoot>
          </CardRoot>
        ))}
      </SimpleGrid>
      <CardRoot>
        <CardHeader>
          <Text fontSize="xl" fontWeight="medium">
            Embedded OpenSearch Dashboard
          </Text>
        </CardHeader>
        <CardBody>
          <iframe
            src="https://opensearch-dashboard.leadcallsell.com/_dashboards/app/dashboards#/view/dd162170-d5eb-11ee-927b-c3bafe4f2e43?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'2024-03-01T05%3A00%3A00.000Z'%2Cto%3A'2024-04-01T03%3A30%3A00.000Z'))&show-time-filter=true" 
            height="600"
            width="100%"
            style={{ border: "0", borderRadius: "0.75rem" }}
            title="OpenSearch Dashboard"
          />
        </CardBody>
      </CardRoot>

      <CardRoot mb={8}>
        <CardHeader>
          <HStack justify="space-between">
            <Text fontSize="xl" fontWeight="medium">
              Recent Leads
            </Text>
            <Button variant="ghost" colorPalette="blue" size="sm">
              View All
            </Button>
          </HStack>
        </CardHeader>
        <CardBody>
          <Table.Root>
            <TableHeader>
              <TableRow>
                <TableCell as="th">Name</TableCell>
                <TableCell as="th">Email</TableCell>
                <TableCell as="th">Status</TableCell>
                <TableCell as="th">Resort</TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recentLeads.map((lead, i) => (
                <TableRow key={i}>
                  <TableCell>{lead.name}</TableCell>
                  <TableCell>{lead.email}</TableCell>
                  <TableCell>{lead.status}</TableCell>
                  <TableCell>{lead.resortName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table.Root>
        </CardBody>
      </CardRoot>

      
    </Box>
  );
};

export default AdminDashboard;
